import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createEpicMiddleware, combineEpics } from 'redux-observable';

import BookingReducer from './reducers/booking-reducer';
import AppReducer from './reducers/app-reducer';
import BookingModel from './models/booking-model';
import LoginReducer from './reducers/login-reducer';
import HistoryReducer from './reducers/history-reducer';
import ShopifyReducer from './reducers/shopify-reducer';
import NewBookingDuck from './ducks/new-booking-duck';
import OVODuck from './ducks/ovo-duck';
import GeoDuck from './ducks/geo-duck';
import BulkUploadDuck from './ducks/new-bulk-upload-duck';
import NewHistoryDuck from './ducks/new-history-duck';
import CommonDuck from './ducks/common-duck';

import EpicsV2 from './epics/v2';

const combined = combineReducers({
  app: AppReducer,
  booking: BookingReducer,
  login: LoginReducer,
  history: HistoryReducer,
  shopify: ShopifyReducer,
  newBooking: NewBookingDuck.reducer,
  OVO: OVODuck.reducer,
  bulkUpload: BulkUploadDuck.reducer,
  geo: GeoDuck.reducer,
  newHistory: NewHistoryDuck.reducer,
  common: CommonDuck.reducer,
});

const initState = {
  booking: new BookingModel(),
};

const rootEpic = combineEpics(EpicsV2);
const epicMiddleware = createEpicMiddleware();

/**
 * Compose used here with applyMiddleware to setup chrome dev tools for redux
 * @see: https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 */
const store = createStore(
  combined,
  initState,
  compose(
    applyMiddleware(thunk, epicMiddleware),
    /* eslint-disable no-underscore-dangle */
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f,
    /* eslint-enable */
  ),
);

epicMiddleware.run(rootEpic);

export default store;
